import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

import { siteSections } from "../../../../content/siteSections";
import useBlurReveal from "../../../../hooks/useBlurReveal";
import Reveal from "../../Reveal";
import Eyebrow from "../../Eyebrow";

/**
 * Word-by-word manifesto reveal section.
 * Translation: Word-by-word manifesto reveal section.
 *
 * @returns {JSX.Element} Manifesto section.
 */
const Manifesto = () => {
  const { containerRef, wordGroups, revealedCount } = useBlurReveal(
    siteSections.manifesto.lines
  );

  return (
    <section className="manifesto-section">
      <div className="manifesto-section__inner">
        <div className="manifesto-section__eyebrow">
          <Eyebrow>{siteSections.manifesto.eyebrow}</Eyebrow>
          <div className="manifesto-section__eyebrow-line" />
        </div>

        <div ref={containerRef}>
          <h2 className="manifesto-section__heading">{wordGroups.map((group, lineIndex) => (
              <span key={`line-${lineIndex}`} className="manifesto-section__line">
                {group.map((word, wordIndex) => {
                  const wordsBeforeLine = wordGroups
                    .slice(0, lineIndex)
                    .reduce((count, currentGroup) => count + currentGroup.length, 0);
                  const absoluteIndex = wordsBeforeLine + wordIndex + 1;
                  const isAccent = siteSections.manifesto.accentWords.includes(word);
                  const isVisible = absoluteIndex <= revealedCount;

                  return (
                    <span
                      key={`${word}-${wordIndex}`}
                      className={`reveal-word ${isVisible ? "revealed" : ""} ${isAccent ? "is-accent" : ""
                        }`.trim()}
                    >
                      {word}&nbsp;
                    </span>
                  );
                })}
              </span>
            ))}</h2>
        </div>

        <div className="manifesto-section__cta-wrapper">
          <Reveal delay={200}>
            <Link
              to={siteSections.manifesto.cta.href}
              className="inline-link group"
              title="Learn more about our forward-deployed engineering philosophy"
            >
              <span>{siteSections.manifesto.cta.label}</span>
              <ArrowRight size={24} strokeWidth={1.25} aria-hidden="true" />
            </Link>
          </Reveal>
        </div>
      </div>

      <div className="glow-line manifesto-section__divider" />
    </section>
  );
};

export default Manifesto;
